import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const superAdminGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const hasSession = await authService.ensureSession();
  if (!hasSession) {
    return router.createUrlTree(['/auth/login']);
  }

  const isSuperAdmin = await authService.checkIsSuperAdmin();
  if (isSuperAdmin) {
    return true;
  }

  return router.createUrlTree(['/auth/unauthorized']);
};
